<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title">
      <i class="back-btn" @click="goBack()"></i>评论
    </div>
    <div class="separator"></div>
    <div class="conMsg" id="conMsg">
      <div class="message">
        <div v-for="l in logs">
            <div :class="[l.UserType==1?'show':'send']">
                <div class="time">{{l.DateStr}}</div>
                <div class="msg">
                  <div class="logo">
                    <img class="head" :src="headimg" alt />
                    <span class="desc">{{l.UserTypeName}}</span>
                  </div>
                  <p>
                    <i class="msg_input"></i>
                    <span class="c">
                       <img style='max-width:220px' v-if="l.LogType==2" :src="l.LogContent" @click="showCustomImagePreview(l.index)" alt />
                       <template v-else>{{l.LogContent}}</template>
                    </span>
                  </p>
              </div>
            </div>
          </div>
      </div>
      <div class="footer">
        <div class="div1">
          <cube-upload 
            ref="frontUpload"
            :auto="false"
            :max="1"
            @files-added="filesAdded"
            @file-success="successFront"
            @file-error="errFront"
          >
            <div class="clearfix">
              <!-- <cube-upload-file v-for="(file, i) in auth.file1" :file="file" :key="i"></cube-upload-file> -->
              <cube-upload-btn :multiple="false">
                <div class="upload-btn">
                  <i></i>
                </div>
              </cube-upload-btn>
            </div>
          </cube-upload>
          <!-- <img class="pic" src="../assets/images/pic.jpg" alt /> -->
        </div>
        <div class="div2">
          <textarea v-model="content" class="msgtxt" cols rows style="vertical-align:top;outline:none;"></textarea>
        </div>
        <div class="div3">
          <button class="btnsend" type="button"  @click="sendContent">发送</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "errPage",
  data(){
    return {
      headimg:_defaultimg_,
      customIndex:-1,
      imgs: [],
      postData:{
        logContent:"",
        logType:1,
        orderId:""
      },
      content:"",
      logs:[],
      params:{}
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    scrollButtom(){
       this.$nextTick(() => {
        let msg = document.getElementById('conMsg') // 获取对象
        msg.scrollTop = msg.scrollHeight // 滚动高度
      })
    },
    getLogs(){
        var that=this;
        that.$api.getComment(that.postData.orderId).then(res=>{
           var data=res.data.Items;
           data.forEach(function(val,index){
             let log=val;
             if(val.LogType==2){
               that.customIndex++;
               log.index= that.customIndex;
               that.imgs.push(val.LogContent);
             }
              that.logs.push(log);
           })
           that.scrollButtom();
        })
    },
    showCustomImagePreview(index){
        this.customIndex=index;
        this.$createImagePreview({
          imgs: this.imgs,
          initialIndex: this.customIndex,
          loop: false,
          speed: 500,
          onChange: (i) => {
            this.customIndex = i
          },
          onHide: () => {
            console.log('hide')
          }
        }, (h) => {
          return h('div', {
            class: {
              'image-preview-custom-header': true
            },
            slot: 'header'
          }, this.customIndex + 1)
        }).show()
    },
    filesAdded(files) {
      let hasIgnore = false;
      const limitSize = 2 * 1024 * 1024;
      // 最大5M
      const maxSize = 5 * 1024 * 1024;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // 如果选择的图片大小最大限制（这里为5M）则弹出提示
        if (file.size > maxSize) {
          file.ignore = true;
          hasIgnore = true;
          break;
        }
        // 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
        if (file.size > limitSize) {
          this.compressPic(file);
        } else {
          let reads = new FileReader();
          reads.readAsDataURL(file);
          let that = this;
          reads.onload = function(e) {
            var bdata = this.result;
            // file.base64 = bdata;
            that.postData.logContent=bdata;
            that.postData.logType=2;
            that.send();
          };
        }
      }
      hasIgnore &&
        this.$createToast({
          type: "warn",
          time: 1000,
          txt: "图片最大支持5M"
        }).show();

        
    },
    // 图片压缩方法
    compressPic(file) {
      let reads = new FileReader();
      reads.readAsDataURL(file);
      // 注意这里this作用域的问题
      let that = this;
      reads.onload = function(e) {
        var bdata = this.result;
        // 这里quality的范围是（0-1）
        var quality = 0.5;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var img = new Image();
        img.src = bdata;
        img.onload = function() {
          var width = img.width;
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          let data = canvas.toDataURL("image/jpeg", quality);
          that.postData.logContent=data;
          that.postData.logType=2;
          that.send();
        };
      };
    },
    filesRemoved() {},
    successFront() {},
    errFront() {},
    send(){
      let that=this;
      if(!that.postData.logContent){
         that.$message.popup("请输入内容",1000);
         return false;
      }
      that.$api.postComment(that.postData).then(res=>{
        that.postData.logContent="";
        that.content=""
        that.logs=that.logs.concat(res.data);
        that.scrollButtom();
      });
    },
    sendContent(){
        this.postData.logContent=this.content;
        this.postData.logType=1;
        this.send();
    }
  },
  created(){
    this.params=this.$store.state.routerStore.chat;
     this.postData.orderId=this.params.orderId;
     this.getLogs();
   
  }
};
</script>
<style scoped>
g {
  max-width: 100%;
  vertical-align: middle;
}
input {
  outline: none;
}
.conMsg{
  overflow: auto;
 height: calc(100% - 115px);
}
.message {
 
  padding: 15px 15px;
}
.time {
  font-size: 12px !important;
  color: #999;
  margin-bottom: 15px;
  text-align: center;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  background: #1c2238;
  width: 100%;
  border-top: 1px solid rgba(76, 89, 145, 0.6);
  overflow: hidden;
}
.footer > div {
  height: 50px;
  float: left;
  overflow: hidden;
}
.footer > div.div1 {
  width: 20%;
  margin: 0 auto;
}
.footer > div.div2 {
  width: 50%;
  margin: auto;
}
.footer > div.div3 {
  width: 30%;
  text-align: center;
}

.footer .pic {
  float: right;
  margin: 9px 20px 0 0;
  width: 29px;
}
.footer .msgtxt {
  padding: 5px 10px;
  background-color: #3c4468;
  color: #d9e3fd;
  width: 100%;
  margin: 10px 0;
  border-radius: 3px;
  height: 30px;
}
.footer .btnsend {
  padding: 5px 15px;
  margin: auto;
  border-radius: 3px;
  border: none;
  margin-top: 11px;
  background-color: #3c4468;
  color: #d9e3fd;
  margin-left: -15px;
}
.send:after,
.show:after,
.msg:after {
  content: "";
  clear: both;
  display: table;
}

.msg  img.head {
  width: 40px;
  float: left;
}
.msg .logo{

}

.send .logo {
    float: left;
}
.msg .desc{
  display: block;
  font-size: 12px !important;
  margin-top: 45px;
      color: #999;
}


.msg > p {
  float: left;
  margin: 0 15px;
  padding: 10px 15px;
  background-color: #3c4468;
  position: relative;
  border-radius: 3px;
  max-width: 250px;
  line-height: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #d9e3fd;
  word-wrap: break-word;
  overflow: inherit;
}
.msg >p span.c{
 display: inline;
}

.msg_input {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-right: 10px solid #3c4468;
  border-bottom: 5px solid transparent;
  left: -10px;
  top: 13px;
}
.show .msg .logo,
.show .msg p,
.show .msg {
  float: right;
}
.show .msg_input {
  left: auto;
  right: 0;
  transform: rotate(180deg);
  -ms-transform: rotate(180deg); /* IE 9 */
  -moz-transform: rotate(180deg); /* Firefox */
  -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
  -o-transform: rotate(180deg); /* Opera */
}
.send,
.show {
  padding-bottom: 15px;
}

  .upload-btn {
        padding-top: 12%;
        text-align: center;
        }
      .upload-btn i {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url(../assets/images/add.svg) center center no-repeat;
      }
</style>
